<template>
  <div class="table-list">
    <div class="list-table" v-if="tableList&&tableList.length>0">
      <el-table
          :data="tableList"
          class="w-100">
        <el-table-column
            prop="id"
            :label="$t('friends.cashwithdrawalid')">
        </el-table-column>
        <el-table-column
            prop="account"
            :label="$t('friends.accountsreceivable')">
        </el-table-column>
        <el-table-column
            :label="$t('friends.accounttype')">
          <template v-slot="scope">
            {{ filterObj(accountTypeOptions, 'value', scope.row.type).label }}
          </template>
        </el-table-column>
        <el-table-column
            prop="price"
            :label="$t('friends.amount')">
        </el-table-column>
        <el-table-column
            :label="$t('friends.status')">
          <template v-slot="scope">
            {{ filterObj(accountTypeOptions, 'value', scope.row.status).label }}
          </template>
        </el-table-column>
        <el-table-column
            prop="createTime"
            :label="$t('friends.applicationtime')">
        </el-table-column>
        <el-table-column
            prop="remark"
            :label="$t('friends.processingresults')">
        </el-table-column>
      </el-table>
      <div class="large tr mt-2">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
      <div class="small tr mt-2">
        <el-pagination
            @currenct-change="handleCurrentChange"
            :current-page="page"
            small
            layout="prev, pager, next"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 暂无数据-->
    <div v-else class="empty">
      <img :src="`${$g.imgPrefix}/img/common/no-result.webp`">
      <div class="empty-text">{{$t('friends.nodata')}}</div>
    </div>
  </div>
</template>

<script>
import {
  filterObj,
  MessageError
} from "@/util/util"
import {
  getWithdrawalList
} from "@/request/requests"

export default {
  name: "withdrawalsList",
  data() {
    let accountTypeOptions = [
      // 提现渠道
      // {
      //     value: "1",
      //     // label: "은행카드"
      //     // label: "bank card"
      //     label: this.$t('friends.bankcard'),
      // },
      {
        value: "1",
        label: "paypal"
      },
    ];
    let statusOptions = [
      {
        value: "1",
        // label: "승인 대기 중"
        // label: "Waiting for approval"
        label: this.$t('friends.waitingforapproval'),
      },
      {
        value: "2",
        // label: "지불 대기 중"
        // label: "Waiting for payment"
        label: this.$t('friends.waitingforpayment'),
      },
      {
        value: "3",
        // label: "통과하지 못함"
        // label: "not pass"
        label: this.$t('friends.notpass'),
      },
      {
        value: "4",
        // label: "지불됨"
        // label: "Paid"
        label: this.$t('friends.paid'),
      },
    ]
    return {
      accountTypeOptions,
      statusOptions,
      tableList: [],
      page: 1,
      size: 10,
      total: 0,
      screenWidth: null,
      userInfo: {}
    }
  },
  methods: {
    filterObj,
    async getData(userInfo) {
      this.userInfo = userInfo;
      let params = {
        size: this.size,
        page: this.page,
        userid: this.userInfo.id
      }
      let res = await getWithdrawalList(this.$qs.stringify(params))
      if (res.status === "200") {
        this.tableList = res.data?.list;
        this.total = res.data?.total;
      } else {
        MessageError(res.msg);
      }
    },
    handleSizeChange(val) {
      this.size = val;
      this.page = 1;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.size = val;
      this.getTableList();
    },
    calcWidth() {
      this.screenWidth = window.screen.width;
      this.$forceUpdate();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>

.table-list{
  &-title{
    font-size:20px;
    margin-bottom:70px;
  }
  .empty{
    margin-top:40px;
    text-align: center;
    img{
      width:240px;
    }
  }

}
</style>